import { render, staticRenderFns } from "./IconArrowBackNovikov.vue?vue&type=template&id=ffd6beb8&"
import script from "./IconArrowBackNovikov.vue?vue&type=script&lang=ts&"
export * from "./IconArrowBackNovikov.vue?vue&type=script&lang=ts&"
import style0 from "./IconArrowBackNovikov.vue?vue&type=style&index=0&id=ffd6beb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports